  <div class="noReport">
    <mat-icon>grid_off</mat-icon>
    <div>
      <p class="noReportMessage"> {{ 'noData.apologize' | translate }} </p>
      <p class="noReportMessage">  {{ 'noData.reason' | translate }} </p>
      <p class="noReportMessage"> {{ 'noData.find_info' | translate }} <a href="#/help"> {{ 'noData.help' | translate }} </a></p>
    </div>
  </div>